import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetAccounts(start, limit, client, pinned, includeTime) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/account/",
        params: { start, limit, client, pinned, ...(includeTime ? { includeTime: true } : {}) },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetAccountBillingEntities() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/account/billingEntities",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetAccount(accountId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/account/" + accountId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetAccountProjects(accountId, state) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/account/" + accountId + "/projects",
        params: { state: state },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetAccountGroups(accountId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/account/" + accountId + "/groups",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCreateAccount(clientId, accountData) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/account/",
        data: { clientId, accountData },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateAccount(accountId, accountData) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/account/" + accountId,
        data: accountData,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestActivateAccount(accountId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/account/" + accountId + "/activate",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeactivateAccount(accountId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/account/" + accountId + "/deactivate",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetAccountMembers(accountId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/account/" + accountId + "/members",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestAddAccountMembers(accountId, accountMembers) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/account/" + accountId + "/members",
        data: { accountMembers },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRemoveAccountMembers(accountId, accountMembers) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/account/" + accountId + "/members",
        data: { accountMembers },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteAccount(accountId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/account/" + accountId,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRestoreAccount(accountId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/account/" + accountId + "/restore",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetAccountPeople(accountId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/account/" + accountId + "/members",
        withCredentials: true,
        crossorigin: true
    });
}
